// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"112":"b9e4012d","387":"6ceb4d02","440":"119123ac"}[chunkId] + ".css";
};